import { ApiLink } from "../../../APILink/ApiLink";
import { errorAlert } from "../../../Components/Alerts";
import axios from "axios";
import authHeader from "../../../Auth/authHeader";
import { useContext, useEffect, useState } from "react";
import { FiscalYearContext } from "../../../FiscalYear/FiscalYearContext";
import '../../../Style/Kartela.scss';
import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Legend,
    LabelList
} from "recharts";
import { ElementsParagraph, TitleElements } from "../../../Components/HeadersCRUD-s";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';
import DataGridComponent from "../../../Components/DataGridComponent";
import { FinancialHeader, MaterialSintetikHeaders, MaterialAnalitikHeaders } from "../GridHeaders/FinancialHeader";
import DataGridShowDetails from "../../../Components/DataGridShowDetails";
import { AddActionsButton } from "../../../Components/AddElementsButton";
import { AiOutlineClose } from "react-icons/ai";

const COLORS = ["green", "blue", "purple"];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    index
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor={x > cx ? "start" : "end"}
            dominantBaseline="central"
        >
            {value}
        </text>
    );
};

export default function ClientDetails(props) {
    const { accountID, accName } = props;

    const [accountName, setAccountName] = useState("")
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const [showOtherTable, setShowOtherTable] = useState(false);
    const [debiKrediData, setDebiKrediData] = useState([]);
    const [analiticFinancial, setAnalitikFinancial] = useState([]);
    const [materialSintetikData, setMaterialSintetikData] = useState([]);
    const [materialAnalitikData, setMaterialAnalitikData] = useState([]);
    const [pieChartData, setPieChartData] = useState([]);


    const [clients, setClients] = useState([]);

    const fetchCreditDebitAccount = async (accountID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getDebitAndCreditForClients', {
                headers,
                params: { year: fiscalYear, accountID: accountID }
            });
            setShowOtherTable(false);
            setDebiKrediData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchKartelaAnalitike = async (accountID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaFinanciareAnalitike', {
                headers,
                params: { fiscalYear: fiscalYear, accountID: accountID }
            });
            setAnalitikFinancial(response.data);
            setShowOtherTable(false);

            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchMaterialSintetikData = async (accountID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaMaterialeSintetike', {
                headers,
                params: { fiscalYear: fiscalYear, accountID: accountID }
            });
            setMaterialSintetikData(response.data);
            setShowOtherTable(false);
            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchMaterialAnalitikData = async (fiscalYear, accountID, articleID) => {

        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/getKartelaMaterialeAnalitike', {
                headers,
                params: { fiscalYear: fiscalYear, accountID: accountID, articleID: articleID }
            });
            setShowOtherTable(true);
            setMaterialAnalitikData(response.data);
            console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const fetchPieChartData = async (accountID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/pieChartBalance', {
                headers,
                params: {
                    fiscalYear: fiscalYear, // Ky duhet të përputhet me backend
                    accountID: accountID   // Dhe ky gjithashtu
                }
            });
            setShowOtherTable(false);
            setPieChartData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };


    const fetchClients = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 105 } });
            setClients(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleAutocompleteChangeClient = (event, value) => {
        if (value && value.AccountID) {
            setAccountName(value.AccountName);
            fetchCreditDebitAccount(value.AccountID);
            fetchKartelaAnalitike(value.AccountID);
            fetchMaterialSintetikData(value.AccountID);
            fetchPieChartData(value.AccountID);
            setShowOtherTable(false);

        } else {
            // Në rast se vlera është pastruar
        }
    };

    const defaultPropsClients = {
        options: clients,
        getOptionLabel: (option) =>
            `${option.IdentificationNumber} - ${option.AccountName}` || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {option.IdentificationNumber}<br />
                        {option.AccountName}
                    </span>
                </li>
            </>
        ),
    };

    const rows = analiticFinancial.map((item, index) => ({
        id: index + 1,
        actionType: item.ActionType,
        accName: item.AccountName,
        idNumber: item.IdentificationNumber,
        comment: item.Comment,
        date: item.Date,
        debit: item.Debit,
        credit: item.Credit,
        progressive: item.Progressive,
    }));


    const materialSintetikRows = materialSintetikData.map((item, index) => ({
        id: ++index,
        // accID: item.AccountID,
        Barcode: item.AccountID,
        ArticleName: item.ArticleName,
        totalTransaction: item.TotalTransactions,
        TotalQtyOutput: item.TotalQtyOutput,
        AvgPriceWithoutVAT: item.AvgPriceWithoutVAT,
        TotalAmount: item.TotalAmount,
        showDetails: item.AccountID,
        articleIDForShow: item.ArticleID,
        rowInfo: item
    }));

    const materialAnalitikRows = materialAnalitikData.map((item, index) => ({
        id: ++index,
        ActionType: item.ActionType,
        Barcode: item.Barcode,
        ArticleName: item.ArticleName,
        date: item.Date,
        QtyOutput: item.QtyOutput,
        PriceWithVAT: item.PriceWithoutVAT,
        TotalAmount: item.TotalAmount,
        showDetails: item.AccountID,
        rowInfo: item
    }));

    useEffect(() => {
        if (accName) {
            setAccountName(accName);
        }
    }, [accName]);

    useEffect(() => {
        if (accountID) {
            fetchCreditDebitAccount(accountID);
            fetchKartelaAnalitike(accountID);
            fetchMaterialSintetikData(accountID);
            fetchPieChartData(accountID);
        }
    }, [accountID, fiscalYear]);

    useEffect(() => {
        fetchClients();
    }, [])

    return (
        <div className="Card_AccountDetails__Container">
            <div>
                <TitleElements
                    // icon={SiHyperledger}
                    title={`Kartela financiare e klientit: ${accountName}`}
                />

                <ElementsParagraph text="Kartela e klientit shfaq informacionet kryesore dhe është e përshtatur për shtypje." />
            </div>

            <div className="Card_AccountDetails__Container__SelectList">
                <Autocomplete
                    // style={{ width: "30%" }}
                    className="Card_AccountDetails__Container__SelectList__AutoComplete"
                    {...defaultPropsClients}
                    id="include-input-in-list"
                    includeInputInList
                    onChange={handleAutocompleteChangeClient}
                    isOptionEqualToValue={(option, value) => option.AccountID === value.AccountID} // Shto funksionin isOptionEqualToValue
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // style={{ width: "55% " }}
                            // className="Card_AccountDetails__Container__SelectList__TextField"
                            label="Kerko Klientin"
                        />
                    )}
                />
            </div>

            <hr></hr>
            <div className="AccountDetails__Container__BarChart" >
                <div className="AccountDetails__Container__BarChart__one">
                    <ResponsiveContainer height={400} >
                        <BarChart className="AccountDetails__Container__BarChart__one__chart__Inside"
                            // width={1200}
                            // height={400}
                            data={debiKrediData}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="MonthNumber" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Te arketueshme" fill="green" minPointSize={0}>
                                <br></br>
                                {/* <LabelList dataKey="MonthNumber" /> */}
                            </Bar>
                            <Bar dataKey="Arketimet" fill="blue" minPointSize={0} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div className="AccountDetails__Container__BarChart__two">
                    <ResponsiveContainer width="100%" height={400}>
                        <PieChart >
                            <Legend />
                            <Pie
                                data={pieChartData}
                                // cx={200}
                                // cy={200}
                                labelLine={false}
                                label={renderCustomizedLabel}
                                outerRadius={140}
                                fill="#8884d8"
                                dataKey="value"
                            >
                                {pieChartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer >
                </div >
            </div >
            <br></br>
            <ElementsParagraph text="Kartela Financiare Analitike" />
            <DataGridComponent columns={FinancialHeader} rows={rows} />
            <br></br>
            <ElementsParagraph text="Kartela Materiale Sitentike" />
            <DataGridShowDetails
                columns={MaterialSintetikHeaders}
                rows={materialSintetikRows}
                fetchAccountsDetails={fetchMaterialAnalitikData}
                height={500}
            />
            <br></br>
            {
                showOtherTable ?
                    <>
                        <div className="Card_AccountDetails__Container__ResButton">
                            <ElementsParagraph text="Kartela Materiale Analitike" />

                            <AddActionsButton
                                text="Mbyll"
                                onClick={() => setShowOtherTable(false)}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div>
                        <DataGridComponent columns={MaterialAnalitikHeaders} rows={materialAnalitikRows} />

                    </>
                    :
                    <></>
            }
            <br></br>
        </div >
    )
}

